import { useTranslation } from 'react-i18next';
import { StickyBottomContainer } from './StickyBottomContainer';
import { ReactComponent as ArrowIcon } from 'assets/images/arrow-long-icon.svg';
import { AuthCookieContext } from 'utils/context';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

export function ContinueButton({
  pageName,
  text,
  onClick,
  beforeSlot,
  ...props
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { templateConfig } = useContext(AuthCookieContext);
  const quizConfig = templateConfig?.quizConfig;
  const nextPage = quizConfig?.[pageName]?.nextPage;

  const handleContinue = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(`./${nextPage}`);
    }
  };

  return (
    <StickyBottomContainer
      sx={{
        px: 2,
        boxSizing: 'border-box',
      }}
    >
      {beforeSlot}
      <Button
        size="large"
        fullWidth
        onClick={handleContinue}
        sx={{ gap: 1 }}
        {...props}
      >
        {text ? text : t('buttons.continue')}
        <ArrowIcon />
      </Button>
    </StickyBottomContainer>
  );
}
